import type {Cardinality} from 'schemaDefinition/types';

export const hasMaxItems = <T>(
  items: T[],
  cardinality?: Cardinality,
): boolean => cardinality === '2' && items.length >= 2;
